import React from 'react';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions'
import { fetchSubscriptionFromUser, updateSubscription } from '../../../../../Redux/Actions/EndUser/SubscriptionActions';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Input } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import './SubscriptionDetails.scss'

class SubscriptionDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			subscriptionInEdit: {
				isSubscribed: false
			},
		};
	}
	componentWillMount() {
		this.props.fetchSubscriptionFromUser(this.props.membershipId)
	}
	componentDidMount() {
		this.props.fetchStates();
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.subscriptions !== undefined) {
			this.setState({subscriptionInEdit: nextProps.subscriptions})
		}
	}

	handleInputChange = (event) => {
        let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.subscriptionInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
			subscriptionInEdit: edited
		});
    };

	cancel = () => {
		this.setState({subscriptionInEdit: {}});
	};

	handleSubmit = (event) => {
		event.preventDefault();
		this.props.updateSubscription(this.state.subscriptionInEdit);
		this.cancel();
	};

	handleState = (event) => {
		const value = event.target.value;
		if (value !== null) {
            this.setState({ subscriptionInEdit: { ...this.state.subscriptionInEdit, state: value } });
        }
	};

	render() {
		return (
			<div className="subscription-details">
				<form className="subscription-details-form card" onSubmit={this.handleSubmit}>

					<div className="list-group-item form-group">
						<div className="custom-control custom-checkbox">
							<input
								name="isSubscribed"
								id="isSubscribed"
								type="checkbox"
								className="custom-control-input"
								checked={this.state.subscriptionInEdit.isSubscribed}
								onChange={this.handleInputChange}
							/>
							<label className="custom-control-label" htmlFor="isSubscribed">I would like to receive the cattleman magazine</label>
						</div>
					</div>

					<div className="list-group-item form-group">
						<label>Preferred Mailing First Name:</label>
						<Input
							name="firstName"
							type="text"
							className="form-control"
							value={this.state.subscriptionInEdit.firstName}
							onChange={this.handleInputChange} 
						/>
					</div>

					<div className="list-group-item form-group">
						<label>Preferred Mailing Last Name:</label>
						<Input
							name="lastName"
							type="text"
							className="form-control"
							value={this.state.subscriptionInEdit.lastName}
							onChange={this.handleInputChange} 
						/>
					</div>

					<div className="list-group-item form-group">
						<label>Preferred Mailing Address 1:</label>
						<Input
							name="mailingAddress1"
							type="text"
							className="form-control"
							value={this.state.subscriptionInEdit.mailingAddress1}
							onChange={this.handleInputChange} 
						/>
					</div>

					<div className="list-group-item form-group">
						<label>Preferred Mailing Address 2:</label>
						<Input
							name="mailingAddress2"
							type="text"
							className="form-control"
							value={this.state.subscriptionInEdit.mailingAddress2}
							onChange={this.handleInputChange}
						/>
					</div>

					<div className="list-group-item form-group">
						<label>City:</label>
						<Input
							type="text"
							name="mailingCity"
							className="form-control"
							value={this.state.subscriptionInEdit.mailingCity}
							onChange={this.handleInputChange}
						/>
					</div>

					<div className="list-group-item form-group">
						<label htmlFor="State" className="">State:</label>
						<DropDownList data={this.props.common.states}
							dataItemKey="id"
							textField="name"
							onChange={this.handleState}
							value={this.state.subscriptionInEdit.state}
							allowCustom={false}
							filterable={false}
							clearButton={false}
							width={300}
							required={true}
						/>
					</div>

					<div className="list-group-item form-group">
						<label>Zip:</label>
						<Input
							pattern="(\d{5}([\-]\d{4})?)"
							type="text"
							placeholder="12345"
							title="Zip Code (Format: 12345 or 12345-6789)"
							name="mailingZip"
							className="form-control"
							value={this.state.subscriptionInEdit.mailingZip}
							onChange={this.handleInputChange}
						/>
					</div>

					<div className="list-group-item">
						<button className="btnPrimary btn btn-primary btn-block" name="save" type="submit">SAVE</button>
					</div>
					
				</form>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		common: state.common,
		subscriptions: state.subscription.subscriptions[0],
	};
}

export default withRouter(
	connect(mapStateToProps, {
		fetchStates,
		updateSubscription,
		fetchSubscriptionFromUser,
	})(SubscriptionDetails)
);
